module.exports = __webpack_public_path__ + "img/manager_register_3.910897ea.png";